export const counterpartiesDataGridStyle = {
  '& .MuiDataGrid-columnHeader:focus, & .MuiDataGrid-columnHeader:focus-within':
    {
      outline: 'none'
    },
  '& .MuiDataGrid-columnHeader:focus-visible, & .MuiDataGrid-columnHeader:has(:focus-visible)':
    {
      outline: '1px solid rgba(7, 141, 238, 0.5)',
      outlineOffset: '-1px'
    }
} as const;
